import * as React from 'react';

import { useStrings } from 'src/providers';

import AddAndDeclineProtection from 'src/components/Shared/AddAndDeclineProtection';
import { BulletPoints } from './BulletPoints';
import { ContractSelector } from './ContractSelector';
import { Footer } from './Footer';

import { StyledMain } from './StyledSlideOut';

interface IMainProps {
  onFAQClicked: React.MouseEventHandler<HTMLButtonElement>;
  closeButtonRef: React.RefObject<HTMLButtonElement>;
}

export function Main(props: IMainProps) {
  const { onFAQClicked, closeButtonRef } = props;
  const { headline } = useStrings();

  // Focuses close button when switching back to Main from FAQ
  React.useEffect(() => {
    if (closeButtonRef?.current) {
      closeButtonRef?.current?.focus();
    }
  }, [closeButtonRef]);

  return (
    <StyledMain>
      <h1 className="header" data-test="header">
        {headline}
      </h1>

      <BulletPoints className="bullet-points" />

      <ContractSelector className="contract-selector" />

      <AddAndDeclineProtection />

      <Footer className="footer" onFAQClicked={onFAQClicked} />
    </StyledMain>
  );
}
